<template>
	<form
		class="search"
		:class="{ 'search--hide': !isShow }"
		@submit.prevent="onSubmit"
	>
		<button class="search__toggle" @click="onToggle">
			검색조건 {{ isShow ? '숨기기' : '펼치기' }}
		</button>
		<table class="search__table table-main">
			<colgroup>
				<col style="width: 10%; background: #f4f7fa" />
				<col style="width: 40%" />
				<col style="width: 10%; background: #f4f7fa" />
				<col style="width: 40%" />
			</colgroup>
			<tbody>
				<tr>
					<th>브랜드</th>
					<td>
						<search-brand
							ref="searchBrand"
							selected-placeholder="브랜드를 선택해 주세요"
							@change="onBrandIdChange"
						/>
					</td>
					<th>기간</th>
					<td>
						<DateRange v-model="datePeriod" type="date" />
					</td>
				</tr>
				<tr>
					<th>제품명</th>
					<td>
						<input
							v-model="productTitle"
							aria-label="제품명"
							type="text"
						/>
					</td>
					<th>상태별</th>
					<td>
						<RadioList v-model="stateType" :radioList="stateList" />
					</td>
				</tr>
			</tbody>
		</table>
		<div class="search__buttons">
			<button
				type="submit"
				class="btn btn-main blue"
				v-text="'검색하기'"
			/>
			<button
				type="button"
				class="btn btn-main blue bordered"
				v-text="'다시작성'"
				@click="onReset"
			/>
		</div>
	</form>
</template>
<script>
	import SearchBrand from '@/components/SearchBrand';
	import DateRange from '@/components/DateRange';
	import RadioList from '@/components/RadioList';

	export default {
		name: 'MonthlyProductSearch',
		components: {
			SearchBrand,
			DateRange,
			RadioList,
		},
		data() {
			return {
				isShow: false,
				datePeriod: { from: '', to: '' },
				productTitle: '',
				stateType: null,
				idBrand: null,
				brandTitle: '',
				stateList: [
					{ id: 1, value: '대기중' },
					{ id: 2, value: '진행중' },
					{ id: 3, value: '완료' },
					{ id: 4, value: '중지' },
				],
			};
		},
		methods: {
			setSearchArgs(args) {
				const keys = Object.keys(args);

				keys.forEach(key => {
					if (key === 'stateType') {
						this[key] = Number(args[key]);
					} else {
						this[key] = args[key];
					}
				});

				if (args.idBrand && args.brandTitle) {
					this.$refs.searchBrand.setBrand(
						args.idBrand,
						args.brandTitle
					);
				}

				this.datePeriod = {
					from: args.dateMin || '',
					to: args.dateMax || '',
				};

				// Query 에 값이 없거나 offset 만 존재할 경우에는 검색창 숨김
				this.isShow =
					keys.length !== 0 &&
					!(keys.length === 1 && keys.indexOf('offset') > -1);
			},
			onToggle() {
				this.isShow = !this.isShow;
			},
			onBrandIdChange({ idBrand, brandTitle }) {
				this.idBrand = idBrand;
				this.brandTitle = brandTitle;
			},
			onSubmit() {
				this.$emit('submit', {
					idBrand: this.idBrand,
					brandTitle: this.brandTitle,
					dateMin: this.datePeriod.from,
					dateMax: this.datePeriod.to,
					productTitle: this.productTitle.trim(),
					stateType: this.stateType,
				});
			},
			onReset() {
				this.datePeriod = { from: '', to: '' };
				this.productTitle = '';
				this.stateType = null;
				this.brandTitle = '';

				this.$refs.searchBrand.init();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.search {
		position: relative;
		margin-top: 1em;
	}

	.search__toggle {
		position: absolute;
		padding: 1em;
		right: 0;
		bottom: 26px;
		background: $btn-blue;
		border-radius: 0 0 1em 1em;
		color: #fff;
		font-weight: bold;
	}

	.search--hide {
		max-height: 1px;

		.search__toggle {
			bottom: -23px;
		}

		.search__table,
		.search__buttons {
			display: none;
		}
	}

	.search__buttons {
		padding: 1em 0;
		text-align: center;
	}
</style>
